// jacques-andre-editeur/JAEfrontend/src/screens/admin/OrderByIdScreen.jsx

import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col, ListGroup, Card } from 'react-bootstrap';
import { FaCheck, FaTimes } from 'react-icons/fa';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useGetOrderDetailsQuery } from '../../slices/ordersApiSlice';

const OrderByIdScreen = () => {
  const { id: orderId } = useParams();

  const { data: order, isLoading, error } = useGetOrderDetailsQuery(orderId);

  return (
    <Container>
      <h1>
        Commande n° {order?.orderNumber || '—'} du {order?.createdAt.substring(0, 10)}
      </h1>

      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        <>
          <Row>
            <Col md={8}>
              <ListGroup variant="flush">

                {/* Adresse d'expédition (si différente) */}
                {order.shippingAddress?.prenom && (
                  <ListGroup.Item>
                    <h2>Adresse de livraison (différente de l'adresse de facturation)</h2>
                    <p>
                      <strong>Nom : </strong>
                      {order.shippingAddress.prenom} {order.shippingAddress.nom}
                    </p>
                    {order.shippingAddress.entreprise && (
                      <p><strong>Entreprise : </strong>{order.shippingAddress.entreprise}</p>
                    )}
                    <p>
                      <strong>Adresse : </strong>
                      {order.shippingAddress.rue}, {order.shippingAddress.complement && `${order.shippingAddress.complement}, `}
                      {order.shippingAddress.codePostal} {order.shippingAddress.ville}, {order.shippingAddress.pays}
                    </p>
                    <p><strong>Téléphone portable : </strong>{order.shippingAddress.telephonePortable}</p>
                    <p><strong>Téléphone fixe : </strong>{order.shippingAddress.telephoneFixe}</p>
                    <p><strong>Email : </strong>{order.shippingAddress.email}</p>
                  </ListGroup.Item>
                )}
                
                {/* Adresse de facturation */}
                <ListGroup.Item>
                  <h2>Adresse de facturation</h2>
                  <p>
                    <strong>Nom : </strong>
                    {order.billingAddress.prenom} {order.billingAddress.nom}
                  </p>
                  {order.billingAddress.entreprise && (
                    <p><strong>Entreprise : </strong>{order.billingAddress.entreprise}</p>
                  )}
                  <p>
                    <strong>Adresse : </strong>
                    {order.billingAddress.rue}, {order.billingAddress.complement && `${order.billingAddress.complement}, `}
                    {order.billingAddress.codePostal} {order.billingAddress.ville}, {order.billingAddress.pays}
                  </p>
                  <p><strong>Téléphone portable : </strong>{order.billingAddress.telephonePortable}</p>
                  <p><strong>Téléphone fixe : </strong>{order.billingAddress.telephoneFixe}</p>
                  <p><strong>Email: </strong>{order.billingAddress.email}</p>
                </ListGroup.Item>

                {/* Liste des articles */}
                <ListGroup.Item>
                  <h2>Articles commandés</h2>
                  {order.orderItems.length === 0 ? (
                    <Message>Commande vide</Message>
                  ) : (
                    <ListGroup variant="flush">
                      {order.orderItems.map((item, index) => (
                        <ListGroup.Item key={index}>
                          <Row>
                            <Col>
                              <Link to={`/livre/${item.book}`}>{item.name}</Link>
                            </Col>
                            <Col md={4}>
                              {item.qty} x {item.price} € ={' '}
                              {(item.qty * item.price).toFixed(2)} €
                            </Col>
                          </Row>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )}
                </ListGroup.Item>
              </ListGroup>

{/* Bloc adresses brutes sans accents / sans virgules / avec sauts de ligne */}
<ListGroup.Item>
  <h2>Adresses (format brut)</h2>

  {/* Fonction utilitaire : retirer accents + caractères spéciaux */}
  {(() => {
    const normalize = (txt) =>
      txt
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // retire accents
        .replace(/[,]/g, "")            // retire virgules
        .trim();

    const formatAddress = (addr) => [
      normalize(addr.prenom) + " " + normalize(addr.nom),
      addr.entreprise ? normalize(addr.entreprise) : "",
      normalize(addr.rue),
      addr.complement ? normalize(addr.complement) : "",
      normalize(addr.codePostal + " " + addr.ville),
      normalize(addr.pays),
      normalize(addr.telephonePortable || ""),
      normalize(addr.telephoneFixe || ""),
      normalize(addr.email || "")
    ]
      .filter(Boolean)
      .join("\n");

    return (
      <pre style={{ whiteSpace: "pre-line", fontSize: "0.9rem" }}>
        {`COMMANDE ${order.orderNumber}\n\n`}
        {/* Adresse de facturation */}
        {formatAddress(order.billingAddress)}

        {/* Adresse de livraison si différente */}
        {order.shippingAddress?.prenom && (
          "\n\n" + formatAddress(order.shippingAddress)
        )}
      </pre>
    );
  })()}
</ListGroup.Item>



            </Col>

            {/* Résumé de la commande */}
            <Col md={4}>
              <Card>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <h2>Résumé</h2>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>Articles</Col>
                      <Col>{order.itemsPrice.toFixed(2)} €</Col>
                    </Row>
                    <Row>
                      <Col>TVA</Col>
                      <Col>{order.taxPrice.toFixed(2)} €</Col>
                    </Row>
                    <Row>
                      <Col>Livraison</Col>
                      <Col>{order.shippingPrice.toFixed(2)} €</Col>
                    </Row>
                    <Row>
                      <Col><strong>Total</strong></Col>
                      <Col><strong>{order.totalPrice.toFixed(2)} €</strong></Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <p>
                      <strong>Payée :</strong>{' '}
                      {order.isPaid ? (
                        <span><FaCheck style={{ color: 'green' }} /> le {order.paidAt && order.paidAt.substring(0, 10)}</span>
                      ) : (
                        <span><FaTimes style={{ color: 'red' }} /></span>
                      )}
                    </p>
                    <p>
                      <strong>Envoyée :</strong>{' '}
                      {order.isSent ? (
                        <span><FaCheck style={{ color: 'green' }} /> le {order.sentAt && order.sentAt.substring(0, 10)}</span>
                      ) : (
                        <span><FaTimes style={{ color: 'red' }} /></span>
                      )}
                    </p>
                  </ListGroup.Item>
                </ListGroup>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
};

export default OrderByIdScreen;
